import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}